import React from 'react';
import s from './UI.module.css';

export function Card({ children, style, className }) {
  return <div className={`${s.card} ${className || ''}`} style={style}>{children}</div>;
}

export function CardHead({ title, action }) {
  return (
    <div className={s.cardHead}>
      <span className={s.cardTitle}>{title}</span>
      {action}
    </div>
  );
}

export function Pill({ type, children }) {
  const cls = {
    ready: s.pillReady,
    pending: s.pillPending,
    review: s.pillReview,
    risk: s.pillRisk,
    new: s.pillNew,
  }[type] || s.pillReady;
  return <span className={`${s.pill} ${cls}`}>{children}</span>;
}

export function Btn({ variant = 'primary', children, onClick, style, icon }) {
  return (
    <button
      className={variant === 'ghost' ? s.btnGhost : s.btnPrimary}
      onClick={onClick}
      style={style}
    >
      {icon && <i className={`ti ${icon}`} />}
      {children}
    </button>
  );
}

export function Table({ headers, rows }) {
  return (
    <table className={s.table}>
      <thead>
        <tr>{headers.map((h, i) => <th key={i}>{h}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>{row.map((cell, j) => <td key={j}>{cell}</td>)}</tr>
        ))}
      </tbody>
    </table>
  );
}

export function BarRow({ label, fillPct, fillColor, value }) {
  return (
    <div className={s.barRow}>
      <span className={s.barLabel}>{label}</span>
      <div className={s.barTrack}>
        <div className={s.barFill} style={{ width: `${fillPct}%`, background: fillColor || 'var(--accent)' }} />
      </div>
      <span className={s.barVal}>{value}</span>
    </div>
  );
}

export function Metric({ icon, iconColor, label, value, valueColor, sub, subClass }) {
  return (
    <div className={s.metric}>
      <div className={s.metricLabel}>
        <i className={`ti ${icon}`} style={{ color: iconColor || 'var(--accent)', fontSize: 14 }} />
        {label}
      </div>
      <div className={s.metricVal} style={{ color: valueColor }}>{value}</div>
      {sub && <div className={`${s.metricSub} ${s[subClass] || ''}`}>{sub}</div>}
    </div>
  );
}

export function SectionHead({ title, action }) {
  return (
    <div className={s.sectionHead}>
      <span className={s.sectionTitle}>{title}</span>
      {action}
    </div>
  );
}

export function FilterPills({ items, active, onSelect }) {
  return (
    <div className={s.filters}>
      {items.map((item, i) => (
        <button
          key={i}
          className={`${s.filterPill} ${active === i ? s.filterPillActive : ''}`}
          onClick={() => onSelect(i)}
        >
          {item}
        </button>
      ))}
    </div>
  );
}
